module.exports = __webpack_public_path__ + "img/relationshiptable.ab92b5a0.svg";